<template>
  <div id="interviewManagement">
    <div class="hr_container">
      <van-tabs v-model="active" @change="tabsChange">
        <van-tab title="当前面试" name="2">
          <div class="tab_list">
            <div class="tab_item" v-for="(list, index) in currentList" :key="index">
              <div @click="jumpPageDetail(list)">
                <div class="tab_item_top tab_item_line_height">
                  <div class="picture">
                    <img :src="list.imgUrl" alt="" />
                  </div>
                  <div class="tite_in">{{ list.name }}</div>
                </div>
                <div class="tab_item_info">
                  <div class="info_left">面试时间：</div>
                  <div class="info_right">{{ list.itemTime }}</div>
                </div>
                <div class="tab_item_info">
                  <div class="info_left">应聘岗位：</div>
                  <div class="info_right">{{ list.positionName }}</div>
                </div>
                <div class="tab_item_info">
                  <div class="info_left">联系电话：</div>
                  <div class="info_right setColor">{{ list.tel }}</div>
                </div>
                <div class="tab_item_info">
                  <div class="info_left">面 试 官：</div>
                  <div class="info_right">{{ list.hrName }}</div>
                </div>
              </div>
              <div class="correlation_info">
                <van-button plain type="danger" class="out" @click="outClick(list)">淘汰</van-button>
                <van-button plain type="primary" class="reexamine" @click="reexamineClick(list)">复试</van-button>
                <van-button type="success" class="pass" @click="passClick(list)">通过</van-button>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="面试记录" name="3">
          <div class="tab_list">
            <div class="tab_item" v-for="(list, index) in recordList" :key="index">
              <div class="tab_item_top tab_item_line_height">
                <div class="picture">
                  <img :src="list.imgUrl" alt="" />
                </div>
                <div class="tite_in">{{ list.title }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">面试时间：</div>
                <div class="info_right">{{ list.itemTime }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">应聘岗位：</div>
                <div class="info_right">{{ list.positionName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">联系电话：</div>
                <div class="info_right setColor">{{ list.tel }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">面 试 官：</div>
                <div class="info_right">{{ list.hrName }}</div>
              </div>
              <div class="result_info" v-if="list.interviewResult">
                <img :src="list.interviewResult == '1' ? ms_success : ms_out" alt="" />
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import api from '@/apis/inside'
export default {
  name: "HR",
  data() {
    return {
      ms_success: require('@/assets/recruitment/ms_success.png'),
      ms_out: require('@/assets/recruitment/ms_out.png'),
      active: '2',
      currentList: [],
      recordList: [],
    };
  },
  created() {
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
  },
  mounted() {
    this.selectInterviewRecord()
  },
  methods: {
    //获取面试记录
    selectInterviewRecord() {
      this.currentList = []
      this.recordList = []
      api.selectInterviewRecord({
        hrEmpNo: this.salaryInfo.empNo, // 10005466
        type: this.active,
      }).then((res) => {
        if (res.code == 200) {
          this.currentList = res.data
          this.recordList = res.data
        }
      })
    },
    tabsChange() {
      this.selectInterviewRecord()
    },
    //跳转详情
    jumpPageDetail(list) {
      this.$router.push({
        path: '/HR/interviewDetail',
        query: {
          list: JSON.stringify(list),
        },
      })
    },
    //跳转淘汰
    outClick(list) {
      this.$router.push({
        path: '/HR/outInterview',
        query: {
          list: JSON.stringify(list),
        },
      })
    },
    //跳转复试
    reexamineClick(list) {
      this.$router.push({
        path: '/HR/secondInterview',
        query: {
          list: JSON.stringify(list),
        },
      })
    },
    //跳转通过
    passClick(list) {
      this.$router.push({
        path: '/HR/passInterview',
        query: {
          list: JSON.stringify(list),
        },
      })
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #interviewManagement {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #interviewManagement {
    width: 276px * $zoom;
  }
}
#interviewManagement {
  font-size: 16px * $zoom;
  position: relative;
  .hr_container {
    width: 100%;
    min-height: 100vh;
    background: #F7F9FA;
    padding: 40px 32px;
    .tab_list {
      .tab_item {
        position: relative;
        width: 100%;
        background: #fff;
        margin-top: 24px;
        padding: 30px;
        border-radius: 16px;
        cursor: pointer;
        .tab_item_top {
          overflow: hidden;
          .picture {
            overflow: hidden;
            float: left;
            width: 95px;
            height: 95px;
            border-radius: 50%;
            background: #ccc;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .tite_in {
            float: left;
            margin-left: 20px;
            font-size: 32px;
            font-weight: bold;
            color: #282B32;
          }
          .text_self {
            float: left;
            margin-left: 20px;
            .tite_self {
              margin-top: 6px;
              font-size: 32px;
              font-weight: bold;
              color: #282B32;
            }
            .content {
              margin-top: 6px;
              font-size: 24px;
              color: #969B9E;
            }
          }
          .time {
            float: right;
            font-size: 24px;
            color: #666666;
          }
          .time_margin_top {
            margin-top: 10px;
          }
        }
        .tab_item_line_height {
          line-height: 95px;
        }
        .tab_item_info {
          display: flex;
          margin-top: 20px;
          font-size: 30px;
          line-height: 42px;
          .info_left {
            width: 160px;
            color: #666666;
          }
          .info_right {
            color: #282B32;
          }
          .setColor {
            color: #0089FF;
          }
        }
        .correlation_info {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 40px;
          padding-top: 40px;
          border-top: 2px solid #F1F1F1;
          .van-button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 124px;
            height: 52px;
            margin-left: 40px;
            background: #fff;
            border: 2px solid #E22121;
            border-radius: 8px;
          }
          .reexamine {
            border: 2px solid #5DD5C9;
            color: #5DD5C9;
          }
          .pass {
            background: #4EA27C;
            border: 2px solid #4EA27C;
            color: #fff;
          }
        }
        .result_info {
          position: absolute;
          right: 60px;
          bottom: 50px;
          width: 116px;
          height: 116px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

::v-deep .van-tabs__nav {
  background: transparent;
  display: block;
  .van-tab {
    float: left;
    width: 160px;
    font-size: 32px;
    line-height: 66px;
    color: #969B9E;

  }
  .van-tab--active {
    font-weight: 800;
    color: #282B32;
  }
  .van-tabs__line {
    width: 48px;
    height: 8px;
    background: #4EA27C;
  }
}
</style>
